import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Box, Fab } from '@mui/material'
import celcomLarge from 'assets/brand/celcom/celcom-large.svg'
import celcomSmall from 'assets/brand/celcom/celcom-small.svg'
import orbitCondensed from 'assets/brand/orbit/orbitCondensed.svg'
import orbitLight from 'assets/brand/orbit/orbitLight.svg'
import OrbitSession from 'hooks/useCookies'
import useOrbitFlag from 'hooks/useOrbitFlag'
import PropTypes from 'prop-types'

import NavLinks from './NavbarLinks'
import ProfileMenu from './NavbarProfileMenu'

function SideNavBar({ hideToggle, collapsedSideBar, toggleCollapsedSideBar }) {
  const role = OrbitSession.get('role')
  const FlagNavToggle = useOrbitFlag('fab-navbarToggle')
  const FlagCelcomIcons = useOrbitFlag('iconset-celcom')
  return (
    <div id='sideNavBar'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
          zIndex: '1',
          backgroundColor: ['owner', 'admin', 'demo'].includes(role)
            ? '#151D29'
            : '#000869',
          transition: 'all .3s ease-in-out',
          height: '100vh'
        }}
        width={collapsedSideBar ? '250px' : '100px'}

        /* Different colour for admin and ops page */
      >
        {FlagNavToggle && hideToggle && (
          <Fab
            size='small'
            sx={{
              margin: 0,
              top: 50,
              left: collapsedSideBar ? 230 : 80,
              right: 'auto',
              bottom: 'auto',
              position: 'fixed',
              transition: 'all .3s ease-in-out'
            }}
            onClick={() => {
              toggleCollapsedSideBar(!collapsedSideBar)
            }}
          >
            {collapsedSideBar ? <ChevronLeft /> : <ChevronRight />}
          </Fab>
        )}
        <Box
          component={RouterLink}
          to=''
          sx={{
            width: '250px',
            display: 'flex',
            justifyContent: 'center',
            margin: `16px 0 48px 0`
          }}
          data-cy='orbitLogo'
        >
          {collapsedSideBar ? (
            FlagCelcomIcons ? (
              <img width='75%' src={celcomLarge} />
            ) : (
              <img width='75%' src={orbitLight} />
            )
          ) : FlagCelcomIcons ? (
            <img width='20%' src={celcomSmall} />
          ) : (
            <img width='20%' src={orbitCondensed} />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflowY: 'hidden'
          }}
        >
          <NavLinks role={role} toggled={collapsedSideBar} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid #CFD8E3',
            padding: `8px 4px`,
            width: '100%'
          }}
        >
          <ProfileMenu toggled={collapsedSideBar} />
        </Box>
      </Box>
    </div>
  )
}

SideNavBar.propTypes = {
  hideToggle: PropTypes.bool,
  collapsedSideBar: PropTypes.bool,
  toggleCollapsedSideBar: PropTypes.func
}

export default SideNavBar
